import { NgModule } from '@angular/core';
import { CurrencyPipe, DecimalPipe, PercentPipe } from '@angular/common';
import { BirthdayPipe } from './dashboard-calendar/birthday.pipe';
import { InvestmentService } from './../investment/investment.service';
import { NumWithCommasPipe } from '../shared/num-with-commas.pipe';
import { BracketService } from '../misc/march-madness/bracket.service';
import { TeamService } from '../misc/march-madness/team.service';

@NgModule({
    providers: [
        CurrencyPipe,
        DecimalPipe,
        PercentPipe,
        BirthdayPipe,
        // Preserve ambient providers without importing dashboard UI or feature routes.
        InvestmentService,
        NumWithCommasPipe,
        BracketService,
        TeamService
    ],
})
export class DashboardProvidersModule { }
